import createReducer from '../lib/createReducer';
import * as types from '../actions/types';
import { get, isObject, isArray } from 'lodash';

const initialState = {
  isFetching: false,
  message: '',
  data: {},
  isLoggedIn: false,
  listLink: [],
  userType: ''
};

export const loginReducer = createReducer(initialState, {
  [types.LOGIN_REQUEST](state, action) {
    return {
      ...state,
      username: action.username,
      password: action.password
    };
  },
  [types.LOGIN_RESPONSE](state, action) {
    let userType = '';
    if (
      isObject(get(action.response, 'data.profile', '')) &&
      get(action.response, 'data.profile.EmpCode', false)
    ) {
      userType = 'teacher';
    } else if (
      isArray(get(action.response, 'data.profile', '')) &&
      get(action.response, 'data.profile[0].EnrolmentNo', false)
    ) {
      userType = 'student';
    }

    return {
      ...state,
      data: action.response.data,
      isLoggedIn: true,
      userType: userType,
      listLink: action.response.listLink
    };
  },
  [types.LOGIN_FAILED](state) {
    return {
      ...state,
      isLoggedIn: false
    };
  },
  [types.LOG_OUT](state) {
    return {
      ...state,
      message: '',
      data: {},
      listLink: [],
      isLoggedIn: false
    };
  },
  [types.CHANGE_ACADEMIC_SESSION](state, action) {
    return {
      ...state,
      data: action.response.data
    };
  },
  [types.CREATE_PASSWORD](state, action) {
    return {
      ...state,
      data: action.response
    };
  },
  [types.FORGET_PASSWORD](state, action) {
    return {
      ...state,
      data: action.response,
      setSwipe: action.response.isSwipe
    };
  },
  [types.FORGETPASS_SWIPE](state, action) {
    return {
      ...state,
      isSwipe: action.response
    };
  },
  [types.GENERATEPASS_SWIPE](state, action) {
    return {
      ...state,
      isGenerateSwipe: action.response
    };
  },
  [types.LOGIN_DATA](state, action) {
    return {
      ...state,
      loginData: action.response
    };
  },
  [types.APPLICATION_NUMBER](state, action) {
    return {
      ...state,
      applicationNumber: action.response
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState
    };
  }
});
